import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ToastrService {
  private toastSubject = new Subject<{ message: string, type: string }>();
  toastState$ = this.toastSubject.asObservable();
  constructor() { }

  show(message: string ='', type: string = '') {
    console.log(message,"this is message")
    console.log(type,"this is type")
    this.toastSubject.next({ message, type });
  }
}
